import axios from './axios';


export const getHomeFeed = async (per_page,page,entity_image_types) => {

    try {
        const response = await axios.get(`/feed?feed_products=true&per_page=${per_page}&page=${page}
             ${entity_image_types ? `&entity_image_types=${entity_image_types}` : ''}`);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
    }
    // categories
export const getCategories = async () => {
    try {
        const response = await axios.get('/feed?categories=true&categories_filtered=true&entity_image_types=main_banner,right_banner,right_banner_2,under_hot_deals_banner,hero_deals_2,banner');
        return response;
    } catch (error) {
        return error;
    }
    }
    // get product by category
export const getProductByCategory = async (category,per_page,page) => {
    try {
        const response = await axios.get(`/feed?category=${category}&latest=2&per_page=100`);
        // const response = await axios.get(`/feed?category=${category}&latest=2&per_page=${per_page}&page=${page}`);
        // console.log("Products",response.data.data.products_by_category.data);
        return response
    } catch (error) {
        return error
    }
    }
    // get all with childers categories
export const getAllCategories = async (query='per_page=2000&status=2') => {
    try {
        const response = await axios.get(`/category?${query}`);
        return response;
    } catch (error) {
        return error;
    }
}


export const getCategoryDetail = async (id) => {
    try {
        const response = await axios.get(`/category/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}


export const getNewArrivals = async (page=1, per_page=100) => {
    try {
        const response = await axios.get(`/feed?new_arrivals=true&per_page=${per_page}&page=${page}`);
        return response;
    } catch (error) {
        return error;
    }
}